<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="500">
            <v-card>
                <v-card-title>{{ $t("JOBCARD_TRUCK_LEAVE_TITLE") }}</v-card-title>
                <v-card-text>
                    <v-form
                        ref="form"
                        v-model="valid">

                        <v-menu
                            v-model="dateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="form.leave_date"
                                    :label="$t('JOBCARD_LEAVE_DATE')"
                                    prepend-icon="mdi-calendar-month"
                                    readonly
                                    v-on="on"
                                    :rules="rules.leave_date"
                                ></v-text-field>
                            </template>
                            <v-date-picker 
                                v-model="form.leave_date"
                                @input="dateMenu = false">
                            </v-date-picker>
                        </v-menu>

                        <v-menu
                            ref="leaveTimeMenu"
                            v-model="menu.leave_time"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="form.leave_time"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="form.leave_time"
                                        :label="$t('JOBCARD_LEAVE_TIME')"
                                        prepend-icon="mdi-clock"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                            <v-time-picker
                                v-if="menu.leave_time"
                                v-model="form.leave_time"
                                full-width
                                @click:minute="$refs.leaveTimeMenu.save(form.leave_time)">
                            </v-time-picker>
                        </v-menu>

                        <v-textarea
                            :label="$t('JOBCARD_LEAVE_NOTES')"
                            v-model="form.leave_notes">
                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        :disabled="!valid || loading.submit"
                        :loading="loading.submit"
                        @click="submit">
                        {{ $t('BTN_SAVE') }}
                    </v-btn>
                    <v-btn
                        text
                        @click="close">
                        {{ $t('BTN_CANCEL') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>

<script>
import AlertDialog from '../components/AlertDialog';
import { mapActions } from 'vuex';
import moment from 'moment';
export default {
    name: "JobcardCloseDialog",
    components: {
        AlertDialog
    },
    data() {
        return {
            display: false,
            dateMenu: false,
            valid: false,
            form: {
                id: null,
                leave_date: null,
                leave_time: null,
                leave_notes: null
            },
            rules: {
                leave_date: [
                    v => !!v || this.$t('RULES_REQUIRED_MSG')
                ]
            },
            menu: {
                leave_time: false
            },
            loading: {
                submit: false
            }
        }
    },
    methods: {
        ...mapActions("jobcard", ["fetchJobcard", "updateJobcard"]),
        ...mapActions("jobcardFailure", ["fetchJobcardFailures"]),
        ...mapActions("jobcardMaintenance", ["fetchJobcardMaintenances"]),
        ...mapActions("jobcardSpare", ["fetchJobcardSpares"]),
        ...mapActions("jobcardExternalMaintenance", ["fetchJobcardExternalMaintenances"]),
        open(params) {
            this.form.leave_date = new moment().format("YYYY-MM-DD"),
            this.form.leave_time = new moment().format("HH:mm"),
            this.form.id = params.id;
            this.display = true;
        },
        close() {
            this.display = false;
            this.loading.submit = false;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
        },
        submit() {
            this.loading.submit = true;
            this.updateJobcard({form: this.form, id: this.form.id})
                .then(async response => {
                    await this.fetchJobcard(this.form.id);
                    await this.fetchJobcardFailures(this.$route.params.id);
                    await this.fetchJobcardMaintenances(this.$route.params.id);
                    await this.fetchJobcardSpares(this.$route.params.id);
                    await this.fetchJobcardExternalMaintenances(this.$route.params.id);
                    this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                    this.close();
                })
                .catch(error => {
                    this.close();
                    this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message)
                })
        }
    }
}
</script>